import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/store/auth.store'
import { PageSpinner } from '@fleetops/ui'
import type { UserRole } from '@fleetops/types'
import { hasMinimumRole } from '@/lib/rbac'

interface ProtectedRouteProps {
  minimumRole?: UserRole
  requiredRole?: UserRole
}

export function ProtectedRoute({ minimumRole, requiredRole }: ProtectedRouteProps) {
  const { session, isInitialized } = useAuthStore()

  if (!isInitialized) return <PageSpinner />

  if (!session) return <Navigate to="/login" replace />

  // Supplier users can only access the supplier portal
  if (session.role === 'supplier' && !requiredRole) {
    return <Navigate to="/supplier-portal" replace />
  }

  // Routes that require an exact role (e.g. supplier portal)
  if (requiredRole && session.role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />
  }

  if (minimumRole && !hasMinimumRole(session.role, minimumRole)) {
    return <Navigate to="/unauthorized" replace />
  }

  return <Outlet />
}
